import { render, staticRenderFns } from "./UserEditPage.vue?vue&type=template&id=52f82552&"
import script from "./UserEditPage.vue?vue&type=script&lang=ts&"
export * from "./UserEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./UserEditPage.vue?vue&type=style&index=0&id=52f82552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports